module.exports = __webpack_public_path__ + "static/media/3.797f835e.svg";